import React from "react";
import { AllocationContainer } from "../../../containers";

const Allocation = (props) => {
  return <AllocationContainer {...props} />;
};

export default Allocation;
